module.exports = __webpack_public_path__ + "4938d9944c104a13c100a6661c458a8e.svg";